import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../../assets/image/shiren.png';
import _imports_1 from '../../assets/image/guanyu.png';
import _imports_2 from '../../assets/image/bangzhu.png';
import _imports_3 from '../../assets/image/zx.png';
const _hoisted_1 = {
  class: "my"
};
const _hoisted_2 = {
  key: 1,
  class: "content mb-15"
};
const _hoisted_3 = {
  class: "text1"
};
const _hoisted_4 = {
  class: "content1 bg-fff c000"
};
const _hoisted_5 = {
  key: 0,
  class: "content2 flex aic"
};
import { ref, onMounted, onUnmounted, reactive } from 'vue';
import { useRouter } from 'vue-router';
export default {
  __name: 'index',
  setup(__props) {
    const router = useRouter();
    const data = reactive({
      token: window.localStorage.getItem('token'),
      username: window.localStorage.getItem('username'),
      mobile: window.localStorage.getItem('mobile')
    });
    const goLogin = () => {
      router.push('/login');
      window.localStorage.removeItem('mobile');
      window.localStorage.removeItem('token');
      window.localStorage.removeItem('username');
    };
    onMounted(() => {});
    onUnmounted(() => {});
    return (_ctx, _cache) => {
      const _component_van_nav_bar = _resolveComponent("van-nav-bar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_nav_bar, {
        title: "我的"
      }), !data.token ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: "content mb-15",
        onClick: _cache[0] || (_cache[0] = $event => _ctx.$router.push('/login'))
      }, [...(_cache[2] || (_cache[2] = [_createElementVNode("div", {
        class: "touxiang"
      }, null, -1), _createElementVNode("div", {
        class: "text"
      }, "登录/注册", -1)]))])) : _createCommentVNode("", true), data.token ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_cache[4] || (_cache[4] = _createElementVNode("div", {
        class: "touxiang"
      }, null, -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createTextVNode(_toDisplayString(data.username) + " ", 1), _cache[3] || (_cache[3] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        srcset: ""
      }, null, -1))]), _createElementVNode("p", null, _toDisplayString(data.mobile), 1)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_cache[6] || (_cache[6] = _createElementVNode("div", {
        class: "content2 flex aic",
        style: {
          "border-bottom": "1px solid #f2f1f6"
        }
      }, [_createElementVNode("div", null, [_createElementVNode("img", {
        style: {
          "display": "block"
        },
        src: _imports_1,
        alt: ""
      })]), _createElementVNode("div", null, "关于")], -1)), _cache[7] || (_cache[7] = _createElementVNode("div", {
        class: "content2 flex aic"
      }, [_createElementVNode("div", null, [_createElementVNode("img", {
        style: {
          "display": "block"
        },
        src: _imports_2,
        alt: ""
      })]), _createElementVNode("div", null, "帮助中心")], -1)), data.token ? (_openBlock(), _createElementBlock("div", _hoisted_5, [...(_cache[5] || (_cache[5] = [_createElementVNode("div", null, [_createElementVNode("img", {
        style: {
          "display": "block",
          "width": "20px"
        },
        src: _imports_3,
        alt: ""
      })], -1), _createElementVNode("div", null, "注销账号", -1)]))])) : _createCommentVNode("", true)]), data.token ? (_openBlock(), _createElementBlock("div", {
        key: 2,
        class: "tbox",
        onClick: _cache[1] || (_cache[1] = $event => goLogin())
      }, "退出登录")) : _createCommentVNode("", true)]);
    };
  }
};